import { useUnit } from 'effector-react'
import { useMutation } from 'react-query'

import { $creatorId } from '@/models/creators.ts'

import { createFansList } from '../data/service'

export const useCreateFanList = () => {
  const creatorId = useUnit($creatorId)

  return useMutation(
    ({ linkId, listName }: { linkId: number; listName: string }) => {
      if (!creatorId) {
        throw new Error('Creator id is not available')
      }

      return createFansList(creatorId, linkId, listName)
    },
  )
}
